import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6 } from "styled-components";
import { hasItems } from "~/features/app/utils";
import { Asset, type Props as AssetProps } from "~/features/craft/asset";
type PlainAsset = Record<string, unknown>;
export type GraphicCardsCardViewProps = {
  count: string;
  image?: PlainAsset | null;
  text?: React.ReactNode;
  title?: string | null;
};
export function GraphicCardsCardView({
  count,
  image,
  text,
  title
}: GraphicCardsCardViewProps) {
  return <_StyledDiv>
      {hasItems(image) && <Asset asset={image as AssetProps["asset"]} imageProps={{
      sizes: "lg:33vw",
      ratio: "4/3"
    }} />}
      <_StyledDiv2>
        <_StyledDiv3>
          <_StyledSpan>{count}</_StyledSpan>
          {title && <_StyledH>{title}</_StyledH>}
        </_StyledDiv3>
        {text && <_StyledDiv4>{text}</_StyledDiv4>}
      </_StyledDiv2>
    </_StyledDiv>;
}
var _StyledDiv = _styled("div").withConfig({
  componentId: "sc-sf-qu7c5-0"
})({
  "display": "flex",
  "height": "100%",
  "flexDirection": "column",
  "padding": "2.4rem",
  "@media (min-width: 1024px)": {
    "padding": "4rem"
  }
});
var _StyledDiv2 = _styled2("div").withConfig({
  componentId: "sc-sf-qu7c5-1"
})({
  "display": "flex",
  "flex": "1 1 0%",
  "flexDirection": "column",
  "rowGap": "1.6rem",
  "@media (min-width: 1024px)": {
    "rowGap": "2.4rem"
  }
});
var _StyledDiv3 = _styled3("div").withConfig({
  componentId: "sc-sf-qu7c5-2"
})({
  "marginTop": "2.4rem",
  "display": "flex",
  "alignItems": "center",
  "columnGap": "1.6rem",
  "@media (min-width: 1024px)": {
    "marginTop": "4rem",
    "columnGap": "2.4rem"
  }
});
var _StyledSpan = _styled4("span").withConfig({
  componentId: "sc-sf-qu7c5-3"
})({
  "fontFamily": "Aeonik, ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif",
  "fontSize": "1.2rem",
  "lineHeight": "1.1",
  "letterSpacing": "0.024rem",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "1.4rem",
    "lineHeight": "1.1",
    "letterSpacing": "0.028000000000000004rem",
    "fontWeight": "400"
  }
});
var _StyledH = _styled5("h2").withConfig({
  componentId: "sc-sf-qu7c5-4"
})({
  "fontSize": "2.2rem",
  "lineHeight": "1.2",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "3.2rem",
    "lineHeight": "1.2",
    "letterSpacing": "0.032rem",
    "fontWeight": "400"
  }
});
var _StyledDiv4 = /*#__PURE__*/_styled6("div").withConfig({
  displayName: "graphic-cards-card___StyledDiv4",
  componentId: "sc-4qi0wh-0"
})({
  "marginTop": "auto"
});